import { render, staticRenderFns } from "./EquipDetail.vue?vue&type=template&id=2e9196e1"
import script from "./EquipDetail.vue?vue&type=script&lang=js"
export * from "./EquipDetail.vue?vue&type=script&lang=js"
import style0 from "./EquipDetail.vue?vue&type=style&index=0&id=2e9196e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports